import type { ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@volca/ui/components/ui/dialog";

/**
 * The dialog every pricebook pick opens in. Its body mounts only while open,
 * so a reopened dialog starts from a fresh search.
 */
export const PricebookMatchDialog = ({
  open,
  onOpenChange,
  saving,
  children,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** A save in flight holds the dialog open, so its outcome has somewhere to land. */
  saving: boolean;
  children: ReactNode;
}) => (
  <Dialog
    open={open}
    onOpenChange={(next) => {
      if (saving) return;
      onOpenChange(next);
    }}
  >
    <DialogContent className="gap-6 sm:max-w-[560px]">
      <DialogDescription className="sr-only">
        Choose the pricebook item this line is for
      </DialogDescription>
      <DialogHeader>
        <DialogTitle>Match line to a pricebook item</DialogTitle>
      </DialogHeader>
      {open && children}
    </DialogContent>
  </Dialog>
);
